import utils from 'utils';
import {
  actionRequestLanding,
  actionReceiveLanding,
} from 'actions';
import { wpUrl } from './';

const { checkStatus, parseJSON } = utils.http;

export function fetchLandingMetaUS() {
  return (dispatch) => {
    // Inform state of fetch
    dispatch(actionRequestLanding('usdata'));
    return fetch(`${wpUrl()}/wp-json/prb/v1/datahub/landing-page/us-indicators`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => dispatch(actionReceiveLanding('usdata', data)))
      .catch((error) => dispatch(actionReceiveLanding('error', error)));
  };
}

export function fetchLandingMetaInternational() {
  return (dispatch) => {
    // Inform state of fetch
    dispatch(actionRequestLanding('international'));
    return fetch(`${wpUrl()}/wp-json/prb/v1/datahub/landing-page/international-indicators`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => dispatch(actionReceiveLanding('international', data)))
      .catch((error) => dispatch(actionReceiveLanding('error', error)));
  };
}

export default {
  fetchLandingMetaUS,
  fetchLandingMetaInternational,
};



// WEBPACK FOOTER //
// ./app/services/fetch/fetchLandingMeta.js